export const SubscriptionReducer = (state = {}, action) => {
  switch (action.type) {
    case "GET_SUBSCRIPTION_LIST_REQUEST":
      return {
        loading: true,
        plan: null,
      };
    case "GET_SUBSCRIPTION_LIST_SUCCESS":
      return {
        loading: false,
        plan: action.payload,
      };
    case "GET_SUBSCRIPTION_LIST_FAILED":
      return {
        loading: false,
        error: action.payload,
      };


      
    default: {
      return state;
    }
  }
};
export const addPlanReducer = (state = {}, action) => {
  switch (action.type) {
    case "ADD_PlAN_REQUEST":
      return {
        loading: true,
        isAdded: false,
      };
    case "ADD_PLAN_SUCCESS":
      return {
        loading: false,
        isAdded: true,
        data: action.payload,
      };
    case "ADD_PLAN_FAIL":
      return {
        loading: false,
        isAdded: false,
        error: action.payload,
      };
    case "CLEAR_ERRORS":
      return {
        ...state,
        error: null,
      };
    default:
      return state;
  }
};

export const editPlanReducer = (state = {}, action) => {
  switch (action.type) {
    case "EDIT_PLAN_REQUEST":
      return {
        loading: true,
        isEdited: false,
      };
    case "EDIT_PLAN_SUCCESS":
      return {
        loading: false,
        isEdited: true,
        data: action.payload,
      };
    case "EDIT_PLAN_FAIL":
      return {
        loading: false,
        isEdited: false,
        error: action.payload,
      };
    case "CLEAR_ERRORS":
      return {
        ...state,
        error: null,
      };
    default:
      return state;
  }
};

export const enumsReducer = (state = {}, action) => {
  switch (action.type) {
    case "GET_ENUMS_REQUEST":
      return {
        loading: true,
        enumsData: null,
      };
    case "GET_ENUMS_SUCCESS":
      return {
        loading: false,
        enumsData: action.payload,
      };
    case "GET_ENUMS_FAILED":
      return {
        loading: false,
        getEnums: action.payload,
      };
    default:
      return state;
  }
};

export const viewPlanReducer = (state = {}, action) => {
  switch (action.type) {
    case "VIEW_CURRENT_PlAN_REQUEST":
      return {
        loading: true,
        isEdited: false,
      };
    case "VIEW_CURRENT_PLAN_SUCCESS":
      return {
        loading: false,
        isEdited: true,
        data: action.payload,
      };
    case "VIEW_CURRENT_PLAN_FAIL":
      return {
        loading: false,
        isEdited: false,
        error: action.payload,
      };
    case "CLEAR_ERRORS":
      return {
        ...state,
        error: null,
      };
    default:
      return state;
  }
};
